import { useState } from 'react'

import { Organization } from '../models'
import { axiosInstance } from '../helpers'

export const useOrganization = () => {
    const [organizationList, setOrganizationList] = useState<Organization[]>([])

    const getOrganizationList = async (params: {
        detail?: boolean
        apartment_only?: boolean
        archived?: boolean
    }) => {
        try {
            const response = await axiosInstance.get('company/organization/', {
                params,
            })
            const orgList: Organization[] = response.data
            setOrganizationList(orgList)
        } catch (error: any) {
            console.error(error.response.data.message)
        }
    }

    const updateOrganization = async (request: UpdateOrganizationRequest) => {
        try {
            const response = await axiosInstance.patch(
                `company/update-organization/${request.id}/`,
                request.body,
            )
            setOrganizationList(
                organizationList.map((org) =>
                    org.id === request.id ? response.data : org,
                ),
            )
            const updatedOrganization = response.data
            return updatedOrganization
        } catch (error: any) {
            console.error(error.response.data.message)
            return Promise.reject(error.response.data.message)
        }
    }

    const bulkUpdateBillingUnitRate = async (
        organizationId: number,
        billingUnitRate: number,
    ) => {
        try {
            const response = await axiosInstance.post(
                `company/bulk-update-organization-billing-rates/${organizationId}/`,
                { billable_unit_rate: billingUnitRate },
            )
            return response.data
        } catch (error: any) {
            console.error(error.response.data.message)
            return Promise.reject(error.response.data.message)
        }
    }

    return {
        organizationList,
        getOrganizationList,
        updateOrganization,
        bulkUpdateBillingUnitRate,
    }
}

export interface UpdateOrganizationRequest {
    id: number
    body: {
        name?: string
        slug?: string
        entrata_ar_transaction_code?: string
        archived?: boolean
    }
}
